import {
	faAddressCard,
	faBaby,
	faCalculator,
	faCreditCard,
	faHouse,
	faMoneyBills,
	faMoneyCheckPen,
	faPiggyBank,
	faSearchDollar,
	faHandshake as farHandshake,
	faNewspaper as farNewspaper,
} from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import {
	faBoxDollar as fasBoxDollar,
	faCalculator as fasCalculator,
	faCircleQuestion as fasCircleQuestion,
	faFileInvoiceDollar as fasFileInvoiceDollar,
	faMoneyBills as fasMoneyBills,
	faMoneyCheckDollar as fasMoneyCheckDollar,
	faMoneyCheckDollarPen as fasMoneyCheckDollarPen,
	faPiggyBank as fasPiggyBank,
	faQuestion as fasQuestion,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { faSuitcase, faUserGroup } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { Config } from "@config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { currentYear } from "@utils/current-year";
import { NewsletterSubscribe } from "../NewsletterSubscribe/NewsletterSubscribe";
import { MenuItemBmBadge } from "./components/MenuItemBmBadge";
import type { Menu, MenuItemCategory, MosaicMenu } from "./type";

export const MAIN_MENU_SELECTOR_OPTIONS = [
	{
		id: "retail",
		value: "retail",
		label: "Lakossági",
		prepend: <FontAwesomeIcon icon={faUserGroup} />,
	},
	{
		id: "corporate",
		value: "corporate",
		label: "Vállalati",
		prepend: <FontAwesomeIcon icon={faSuitcase} />,
	},
];

export const RETAIL_MENU: MenuItemCategory[] = [
	{
		title: "Hitel",
		items: [
			{
				title: "Lakáshitel",
				iconElement: (
					<div className="menu-pic">
						<img
							loading="lazy"
							src="/wp-content/themes/bankmonitor/img/menu/icon-mini-set-stack.svg#jzh"
							alt="Lakáshitel"
						/>
					</div>
				),
				url: "/lakashitel-kalkulator/",
				productCount: 492,
				productInfo: {
					title: "Lakáshitel",
					text: (
						<>
							Lakáshitel igényelhető <strong>új</strong> vagy <strong>használt</strong> ingatlan
							megvásárlásához, építéshez, bővítéshez, felújításhoz vagy korszerűsítéshez.
							<br />
							<br />
							Egy jelzáloghitel akár a régebbi, <strong>drágább kölcsönök kiváltására</strong> is
							felhasználható.
						</>
					),
				},
				items: [
					{
						url: "/lakashitel-kalkulator/",
						title: "Lakáshitel kalkulátor",
						productInfo: {
							id: "mortgage-calculator",
							title: "Lakáshitel kalkulátor",
							text: (
								<>
									A magyar banki <strong>lakáshitel ajánlatok 95%</strong>-ának{" "}
									<strong>objektív összehasonlítása</strong> pillalantok alatt.
									<br />
									<br />
									Azonnal láthatod, hogy a szükséges hitelösszeg milyen havi törlesztőt jelent majd a
									számodra.
								</>
							),
						},
					},
					{
						url: "/lakashitel-hitelkivaltas/",
						title: "Hitelkiváltás kalkulátor",
						productInfo: {
							id: "mortgage-redemption",
							title: "Hitelkiváltás kalkulátor",
							text: (
								<>
									A Bankmonitor Hitelkiváltás Kalkulátora meglévő hitelünk vagy hiteleink adatai
									alapján pontos információval szolgál arra nézve, hogy jelenleg találhatunk-e
									kedvezőbb kamatú vagy biztonságosabb jelzálog hitelterméket helyette.
								</>
							),
						},
					},
					{
						url: "/epitesi-hitel/",
						title: "Építési hitel kalkulátor",
						productInfo: {
							id: "epitesi-calculator",
							title: "Építési hitel kalkulátor",
							text: (
								<>
									<strong>10 magyar bank építési hitelei</strong> egy helyen. <br />
									<br />
									Kalkulálj, hasonlítsd össze az ajánlatokat és{" "}
									<strong>spórolj akár milliókat</strong> egy jó döntéssel!
								</>
							),
						},
					},
					{
						url: "/bankmonitor-lakashitel-kamatkedvezmeny/",
						title: "Bankmonitor lakáshitel kamatkedvezmény",
						productInfo: {
							id: "bankmonitor-mortgage-interestdiscount",
							title: "Bankmonitor lakáshitel kamatkedvezmény",
							text: (
								<>
									Minden 10 millió Ft lakáshitel után több mint 1 millió Ft pénzügyi előny érhető el a
									Bankmonitoron keresztül felvett hitellel. Használd ki Te is a kamatkedvezményt.
								</>
							),
						},
					},
					{
						url: "/hitel-lakasfelujitasra/",
						title: "Lakáshitel felújításra",
						productInfo: {
							id: "lakashitel-felujitasi-calculator",
							title: "Lakáshitel felújításra",
							text: (
								<>
									A megfelelő lakáshitelt keresed felújításodhoz? <br />
									<br />
									Kalkulálj és spórolj akár milliókat egy jó döntéssel!
								</>
							),
						},
					},
					{
						url: "/lakashitel-kalkulator/szabad-felhasznalasu-jelzaloghitel-kalkulator/",
						title: "Szabad felhasználású hitel",
						productInfo: {
							id: "szabadfelhasznalasu-calculator",
							title: "Szabad felhasználású hitel kalkulátor",
							text: (
								<>
									Szabad célú jelzáloghitelek akár <strong>100 millió Ft</strong> hitelösszegig.{" "}
									<br />
									<br />
									Tudd meg, hogy kalkulációd alapján <strong>melyik a legkedvezőbb</strong> ajánlat
									számodra és indítsd el az igénylést!{" "}
								</>
							),
						},
					},
					{
						url: "/lakashitel-kalkulator/mennyi-lakashitelt-kaphatok/",
						title: "Mennyi lakáshitelt kaphatok?",
						productInfo: {
							id: "mortgage-how-much",
							title: "Mennyi lakáshitelt kaphatok?",
							text: (
								<>
									Tudd meg, <strong>jövedelmed</strong> és <strong>meglévő hiteleid</strong> alapján
									maximálisan <strong>mekkora összegű lakáshitelt</strong> kaphatsz a magyarországi
									bankoktól.{" "}
								</>
							),
						},
					},
					{
						url: "/csok-plusz-kalkulator/",
						title: "CSOK PLUSZ kalkulátor",
						productInfo: {
							id: "csok-plusz",
							title: "CSOK PLUSZ kalkulátor",
							text: <>Használd a Bankmonitor CSOK PLUSZ kalkulátorát.</>,
						},
					},
					{
						url: "/csok/",
						title: "CSOK-hitel kalkulátor",
						productInfo: {
							id: "csok-loan",
							title: "CSOK-hitel kalkulátor",
							text: (
								<>
									Kalkulálj és válogass a szuperolcsó CSOK-hitelek között!{" "}
									<strong>Maximum 3%-os</strong> kamat és futamidő végéig kiszámítható,{" "}
									<strong>fix havi törlesztő</strong>. Felhasználhatod használt vagy új lakás
									vásárlására, vagy építésre.
								</>
							),
						},
					},
					{
						isHr: true,
					},
				],
			},
			{
				title: "Személyi kölcsön",
				iconElement: (
					<div className="menu-pic">
						<img
							loading="lazy"
							src="/wp-content/themes/bankmonitor/img/menu/icon-mini-set-stack.svg#szk"
							alt="Személyi kölcsön"
						/>
					</div>
				),
				url: "/szemelyi-kolcson/",
				productCount: 48,
				productInfo: {
					id: "personal-loans",
					title: "Személyi kölcsön",
					text: (
						<>
							Akár 12 millió Ft összegű, <strong>szabad felhasználású</strong> személyi kölcsön
							ingatlanfedezet nélkül. Az igényelt hitelösszeg 3-5 napon belül megérkezhet a számlára.
						</>
					),
				},
				items: [
					{
						url: "/szemelyi-kolcson/",
						title: "Személyi kölcsön kalkulátor",
						productInfo: {
							id: "personal-loans-calculator",
							title: "Személyi kölcsön kalkulátor",
							text: (
								<>
									14 bank <strong>szabad felhasználású</strong>, <strong>fix kamatú</strong> szeméi
									kölcsöneinek összehasonlítása pillanatok alatt.
									<br />
									<br />
									Tudd meg, <strong>mekkora összegű személyi hitelt kaphatsz</strong> a jövedelmed
									alapján.{" "}
								</>
							),
						},
					},
					{
						url: "/mennyi-szemelyi-kolcsont-kaphatok/",
						title: "Mennyi kölcsönt kaphatok",
						productInfo: {
							id: "personal-loans-how-much",
							title: "Mennyi kölcsönt kaphatok?",
							text: (
								<>
									Tudd meg, <strong>jövedelmed alapján</strong> maximálisan{" "}
									<strong>mekkora összegű</strong> szabad felhasználású, <strong>fix kamatú</strong>{" "}
									személyi kölcsönt kaphatsz a magyarországi bankoktól.{" "}
								</>
							),
						},
					},
					{
						isHr: true,
					},
					{
						url: "/szemelyi-kolcson-premium/",
						title: "Prémium személyi kölcsön",
						productInfo: {
							id: "personal-loans-sber",
							title: "Prémium személyi kölcsön",
							text: (
								<>
									Szabad felhasználású, fix kamatú személyi kölcsönök{" "}
									<strong>bankváltás nélkül!</strong>
								</>
							),
						},
					},
					{
						url: "/adossagrendezo-hitel/",
						title: "Adósságrendező hitel",
						productInfo: {
							id: "personal-loans-redemption",
							title: "Adósságrendező hitel",
							text: (
								<>
									Nézd meg, hogy mennyit spórolhatsz hiteleid kiváltásával a Bankmonitor
									Adósságrendező hitel kalkulátorával!
								</>
							),
						},
					},
					{
						url: "/nagyosszegu-szemelyi-kolcson/",
						title: "Nagyösszegű személyi kölcsön",
						productInfo: {
							id: "personal-loans-large-amount",
							title: "Nagyösszegű személyi kölcsön",
							text: (
								<>
									Prémium <strong>12 millió forintos</strong> személyi hitel fix kamattal autó
									vásárlásra, szabad felhasználásra, vagy lakásfelújításra.
								</>
							),
						},
					},
					{
						url: "/autohitel/",
						title: "Autóhitel",
						productInfo: {
							id: "autohitel",
							title: "Autóhitel",
							text: (
								<>
									Fix kamatú személyi kölcsönök használt és új{" "}
									<strong>autó vásárlására, fedezet nélkül</strong>, gyors hitelbírálattal és
									folyósítással.
								</>
							),
						},
					},
					{
						url: "/felujitasi-hitel/",
						title: "Személyi kölcsön felújításra",
						productInfo: {
							id: "felujitasi-hitel",
							title: "Felújítási hitel",
							text: (
								<>
									A megfelelő személyi kölcsönt keresed felújításodhoz? <br />
									<br />
									Kalkulálj és <strong>spórolj akár százezreket</strong> egy jó döntéssel!
								</>
							),
						},
					},
				],
			},
			{
				url: "/babavaro-hitel/",
				iconElement: (
					<div className="menu-pic">
						<img
							loading="lazy"
							src="/wp-content/themes/bankmonitor/img/menu/icon-mini-set-stack.svg#babavaro"
							alt="Babaváró hitel"
						/>
					</div>
				),
				title: "Babaváró hitel",
				productCount: 12,
				productInfo: {
					id: "baby-loan",
					title: "Babaváró hitel",
					text: (
						<>
							A Babaváró hitel (vagy Babaváró támogatás) fiatal házasoknak. Akár{" "}
							<strong>10 millió Ft kamatmentes kölcsön</strong>, a második és a harmadik gyermek
							születésekor elengedik a tőketartozás egy részét vagy egészét.{" "}
						</>
					),
				},
				items: [
					{
						url: "/erste-babavaro-hitel/",
						title: "Gyorsított babaváró igénylés",
						productInfo: {
							id: "erste-online-babavaro",
							title: "Gyorsított online babaváró",
							text: (
								<>
									10 nap helyett, akár <strong>2 munkanapos hitelbírálat</strong>, felesleges{" "}
									<strong>személyes találkozó nélkül</strong>. Indítsd el az igénylést pár perc alatt
									és <strong>kövesd élőben</strong> a folyamatot online!
								</>
							),
						},
						badge: <MenuItemBmBadge />,
					},
					{
						url: "/babavaro-hitel/",
						title: "Babaváró kalkulátor",
						productInfo: {
							id: "babavarotamogatas",
							title: "Babaváró kalkulátor",
							text: (
								<>
									Számítsd ki <strong>hitelkalkulátorunkkal</strong>, hogy mennyi babaváró hitelre
									vagy jogosult és <strong>indítsd el akár azonnal</strong> az igénylés folyamatát!
								</>
							),
						},
					},
				],
			},
			{
				url: "/hitelkalkulator/",
				iconElement: (
					<div className="menu-pic">
						<img
							loading="lazy"
							src="/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#hitelkalkulator"
							alt="Hitelkalkulátor"
						/>
					</div>
				),
				title: "Hitelkalkulátor",
				productCount: 540,
				productInfo: {
					id: "loan-calculator",
					title: "Hitelkalkulátor",
					text: (
						<>
							Nem tudod pontosan{" "}
							<strong>
								milyen hitelt szeretnél felvenni? Hitelkalkulátorunk megmutatja számodra a legkedvezőbb
								banki ajánlatokat
							</strong>
							, illetve megtudhatod azt is, hogy mekkora hitelösszeget vehetsz fel.
						</>
					),
				},
			},
			{
				url: "/munkashitel/",
				title: "Munkáshitel",
				productInfo: {
					id: "worker-loan",
					title: "Munkáshitel",
					text: (
						<>
							Tudj meg mindent a frissen bejelentett <strong>munkáshitelről</strong> és{" "}
							<strong>maradj naprakész</strong>.
						</>
					),
				},
			},
			{
				title: "Egyéb hitel",
				productCount: 48,
				productInfo: {
					id: "other-loans",
					title: "Egyéb hitelek",
					text: (
						<>
							Egyéb hitellehetőségek, amelyek <strong>finanszírozási megoldást</strong> jelentenek a
							legkülönfélébb helyzetekben is.
						</>
					),
				},
				items: [
					{
						url: "/hitelkartya/",
						title: "Hitelkártya igénylés",
						productInfo: {
							id: "credit-card",
							title: "Hitelkártyák",
							text: (
								<>
									Hitelkártyáddal szabadon használhatod a bank pénzét a felhasználható hitelkereted
									erejéig. A hitelkártyák egy része ezen kívül{" "}
									<strong>vásárlási kedvezményeket</strong> és{" "}
									<strong>pénzvisszatérítési lehetőséget</strong> is kínál.{" "}
								</>
							),
						},
					},
				],
			},
		],
		productInfo: {
			title: "Hitelek",
			text: (
				<>
					<strong>Jelzáloghitelek</strong> újépítésű és használt ingatlan megvásárlására, felújítására,
					korszerűsítésére és bővítésére, vagy akár meglévő hitel kiváltására.
					<br />
					<br />
					<strong>Személyi kölcsönök</strong> bármilyen célra(autóvásárlás, utazás, hitelkiváltás stb.), akár
					10 millió Ft összegben, rövid átfutási idővel.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Bankszámla",
		items: [
			{
				url: "/bankszamla/",
				title: "Bankszámla kalkulátor",
				productInfo: {
					id: "bank-accounts-calculator",
					title: "Bankszámla kalkulátor",
					text: (
						<>
							A <strong>Bankmonitor bankszámla kereső</strong> segítségével találd meg a személyes
							bankolási szokásaidnak megfelelő lakossági bankszámlát, és{" "}
							<strong>spórolj évente akár több tízezer forintot!</strong> <br />
							<br />
							Bankszámla összehasonlítás, online számlanyitás, ingyenes számlavezetés és még sok más
							lehetőség.
						</>
					),
				},
			},
			{
				url: "/bankszamla/ingyenes-bankszamlak/",
				title: "Ingyenes bankszámlák összehasonlítása",
				productInfo: {
					id: "bank-accounts-calculator",
					title: "Ingyenes bankszámla összehasonlítás és nyitás",
					text: (
						<>
							<strong>Hasonlítsd össze</strong> egyszerűen az <strong>ingyenes</strong> bankszámlákat,
							válaszd ki a számodra legmegfelelőbbet és <strong>nyisd meg online</strong> pillanatok
							alatt!
							<br />
							<br />
							<strong>Spórolj</strong> évente akár <strong>több tízezer forintot</strong>!
						</>
					),
				},
			},
			{
				url: "/bankszamla/ingyenes-bankszamla-online/",
				title: "CIB ECO bankszámla",
				productInfo: {
					id: "cib-eco",
					title: "CIB ECO bankszámla online igénylés",
					text: (
						<>
							Pár perc alatt szerződéskötés, e-nyomonkövetés élőben a számlanyitás során és szakértői
							segítség, ha elakadnál. Kalkulálj és nézd meg, hogy a 2 évig ingyenes CIB ECO bankszámlánál
							számodra van-e jobb!
						</>
					),
				},
				badge: <MenuItemBmBadge />,
			},
			{
				url: "/bankszamla/cib-eco-plusz/",
				title: "CIB ECO Plusz bankszámla",
				productInfo: {
					id: "cib-eco-plusz",
					title: "Ingyenes bankszámla összehasonlítás és nyitás",
					text: (
						<>
							<strong>5 évig teljesen ingyenes</strong> (havi díj és tranzakciós költség nélküli)
							lakossági bankszámla, <strong>ingyenes Gold kártyával</strong>, havi 450 ezer forint
							jóváírástól
						</>
					),
				},
				badge: <MenuItemBmBadge />,
			},
			{
				url: "/bankszamla/ingyenes-bankszamla-nyitas/",
				title: "UniCredit Partner Aktív Nulla bankszámla",
				productInfo: {
					id: "unicredit",
					title: "UniCredit ingyenes bankszámla nyitás",
					text: (
						<>
							2 évig ingyenes bankszámla: ingyenes számlavezetés, tranzakció, utalás, bankkártya.
							Egyszerű, online bankszámlanyitás a bankszámla kereső segítségével.
						</>
					),
				},
				badge: <MenuItemBmBadge />,
			},
			{
				url: "/bankszamla/erste-ingyenes-bankszamla-nyitas/",
				title: "Erste Privilégium 2.0 Partner bankszámla",
				productInfo: {
					id: "erste",
					title: "Erste online bankszámla nyitás",
					text: (
						<p>
							3 évig ingyenes Erste Privilégium 2.0 Partner számla: ingyenes számlavezetés, tranzakció,
							utalás, bankkártya. Használd a bankszámla kalkulátort és élj az online bankszámlanyitás
							lehetőségével.
						</p>
					),
				},
				badge: <MenuItemBmBadge />,
			},
			{
				url: "/raiffeisen-premium-bankszamla/",
				title: "Raiffeisen Premium Banking bankszámla",
				productInfo: {
					id: "unicredit",
					title: "Raiffeisen Premium Banking ingyenes bankszámla",
					text: (
						<>
							A Raiffeisen Prémium Bankszámla egy teljesen ingyenes csomag: díjmentes számlavezetés,
							tranzakció, utalás, bankkártya. Nézd meg a részleteket, használd kalkulátorunkat.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "bank-accounts",
			title: "Bankszámlák",
			text: (
				<>
					<strong>Teljesen ingyenes</strong> (havi díj és tranzakciós költség nélküli) lakossági bankszámla,
					bankszámlák <strong>nyugdíjasoknak</strong>, <strong>diákoknak</strong>,{" "}
					<strong>minimálbéreseknek</strong> és <strong>magas jövedelműeknek</strong>.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Megtakarítás",
		items: [
			{
				url: "/nyugdij-megtakaritas/",
				title: "Nyugdíj megtakarítások",
				items: [
					{
						url: "/nyugdij-megtakaritas/",
						title: "Nyugdíj-megtakarítás kalkulátor",
						productInfo: {
							id: "nyugdij",
							title: "Nyugdíj-megtakarítás kalkulátor",
							text: (
								<>
									Megéri időben gondoskodni nyugdíjas éveidről. <strong>Kalkulálj és tudd meg</strong>
									, hogy <strong>mennyi pénzed lesz</strong>, mire nyugdíjba mész!
								</>
							),
						},
					},
					{
						url: "/megtakaritasok/nyugdijbiztositas/",
						title: "Nyugdíjbiztosítás összehasonlító",
						productInfo: {
							id: "nyugdijbiztositas",
							title: "Nyugdíjbiztosítás összehasonlító",
							text: (
								<>
									Használd ki az <strong>éves 130 ezer Ft-os adójóváírást</strong>! Hasonlítsd össze a
									biztosítók kínálatát és kérd szakértőnk díjmentes segítségét a jó döntésben!
								</>
							),
						},
					},
					{
						url: "/megtakaritasok/onkentes-nyugdijpenztar/",
						title: "Nyugdíjpénztár összehasonlító",
						productInfo: {
							id: "nyugdijpenztar",
							title: "Nyugdíjpénztár összehasonlító",
							text: (
								<>
									Használd ki az <strong>éves 150 ezer Ft-os adójóváírást</strong>! Hasonlítsd össze a
									pénztárak kínálatát és kérd szakértőnk díjmentes segítségét a jó döntésben!
								</>
							),
						},
					},
				],
				productCount: 22,
				productInfo: {
					id: "pensions",
					title: "Nyugdíj-megtakarítás",
					text: (
						<>
							Gondoskodj időben nyugdíjas éveidről! Kalkulálj, hogy megtudd,{" "}
							<strong>mennyi pénzed lesz</strong>, mire nyugdíjba mész és <strong>hasonlíts össze</strong>
							, hogy megtaláld a számodra megfelelő ajánlatot!
						</>
					),
				},
			},
			{
				url: "/megtakaritasok/hold-vagyonkezeles",
				title: "Online vagyonkezelés",
				productInfo: {
					id: "hold-vagyonkezeles",
					title: "Online vagyonkezelési szolgáltatás",
					text: (
						<>
							Indíts <strong>online vagyonkezelési szolgáltatást</strong> néhány kattintással! A{" "}
							<strong>legjobb szakemberek kezelik</strong> a portfoliót és hoznak befektetési döntéseket
							minden nap, hogy <strong>Te azzal foglalkozhass, amivel igazán szeretnél</strong>.
						</>
					),
				},
			},
			{
				url: "/nyugdijkalkulator/",
				title: "Nyugdíjkalkulátor 2025",
				productInfo: {
					id: "nyugdijkalkulator",
					title: "Nyugdíjkalkulátor - tudd meg, mennyit fizet az állam",
					text: (
						<>
							<strong>Számold ki</strong>, hogy mennyi nyugdíjra számíthatsz az államtól! A nyugdíj
							lényegében <strong>mindig kevesebb</strong>, mint a csúcs fizetésed. Mi megmutatjuk, hogyan
							tehetsz szert <strong>adójóváírásra</strong>, miközben a nyugdíjadat is kiegészíted.
						</>
					),
				},
			},
			{
				url: "/megtakaritas-gyerekeknek/",
				title: "Megtakarítás gyerekeknek",
				productInfo: {
					id: "megtakaritas-gyerekeknek",
					title: "Megtakarítás gyerekeknek",
					text: <>Gyermek megtakarítással támogathatjuk gyerekünk továbbtanulását és életkezdését.</>,
				},
			},
			{
				url: "/megtakaritasok/lakastakarek/",
				title: "Lakástakarék",
				productInfo: {
					id: "lakastakarek",
					title: "Lakástakerék",
					text: (
						<>
							A lakástakarékok (LTP) lakáscélú megtakarítási lehetőséget kínálnak kedvező hitellel
							kombinálva.
						</>
					),
				},
			},
			{
				url: "/megtakaritasok/allampapir/",
				title: "Állampapír",
				productInfo: {
					id: "allampapir",
					title: "Állampapír",
					text: (
						<>
							A magyar állampapírok a bankbetéteknél magasabb hozamot kínálnak a megtakarítóknak, a
							bankbetétekkel közel azonos biztonság mellett. Válassz az egy éves vagy ennél rövidebb
							lejáratú kincstárjegyek és az egy évnél hosszabb lejáratú államkötvények közül.
						</>
					),
				},
			},
			{
				url: "/megtakaritasok/bankbetet/",
				title: "Bankbetét",
				productInfo: {
					id: "bankbetet",
					title: "Bankbetét",
					text: (
						<>
							A bankbetét egy olyan pénzösszeg, melyet meghatározott, vagy egy előre nem rögzített
							időszakra elhelyezünk a bankban azon céllal, hogy a későbbiekben kamatot kapjunk, azaz az
							elhelyezett összegnél nagyobb összeget vegyünk majd ki a bankból.
						</>
					),
				},
			},
			{
				url: "/inflacio/",
				title: "Infláció figyelő",
				productInfo: {
					id: "portfolio-tervezo",
					title: "Infláció figyelő",
					text: (
						<>
							Kövesd a magyarországi inflációs adatokat és híreket. Tudd meg mennyivel ér kevesebbet a
							pénzed és mit tudsz ellene tenni.
						</>
					),
				},
			},
			{
				url: "/megtakaritasok/befektetesi-alap/",
				title: "Befektetési alap",
				productInfo: {
					id: "befalap",
					title: "Befeketési alap",
					text: (
						<>
							A Befektetési alapok összegyűjtik az egyes magánbefektetők megtakarításait, a keletkező
							vagyontömeget pedig befektetik.
						</>
					),
				},
			},
			{
				url: Config.buildSsrFriendlyUrl("BM_BEFEKTETES_PORTFOLIO_URL"),
				title: "Portfólió tervező",
				productInfo: {
					id: "portfolio-tervezo",
					title: "Portfólió tervező",
					text: (
						<>
							Több befektetést tartalmazó portfólió összeállításával csökkenthető a befektetési kockázat
							és a hozamingadozás.{" "}
						</>
					),
				},
			},
			{
				url: Config.buildSsrFriendlyUrl("BM_BEFEKTETES_KOCKAZAT_URL"),
				title: "Befektetői teszt",
				productInfo: {
					id: "befektetoi-teszt",
					title: "Befektetői teszt",
					text: (
						<>
							Kiderítheted valós helyzeteken keresztül, hogy mennyire bírod a kockázatot, mert ez a helyes
							befektetési döntések egyik legfontosabb kritériuma.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "savings",
			title: "Megtakarítások és befektetések",
			text: (
				<>
					Hasznos információk a befektetési alapokról, a lakástakarékokról, a nyugdíj-megtakarítási
					lehetőségekről, a bankbetétekről és az állampapírokról. Befektetési tanácsadás szolgáltatás a
					hatékony portfólió kialakításához.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Támogatás",
		items: [
			{
				url: "/csok-plusz/",
				title: "CSOK Plusz",
				productInfo: {
					id: "csok-plusz",
					title: "CSOK Plusz 2024",
					text: (
						<strong>
							Tájékozódj az új, 2024-től érvényes CSOK Plusz aktuális feltételeiről, ismerd meg a
							szabályokat és kalkulálj a Bankmonitor szakértőinek segítségével.
						</strong>
					),
				},
			},
			{
				url: "/falusi-csok/",
				title: "Falusi CSOK",
				productInfo: {
					id: "falusi-csok",
					title: "Falusi CSOK 2024",
					text: (
						<strong>
							Minden egy helyen a Falusi CSOK 2024-től érvényes feltételeiről, igényléséről, a
							támogatáshoz igényelhető kedvezményes lakáshitelről.
						</strong>
					),
				},
			},
			{
				url: "/lakasfelujitasi-tamogatas/",
				title: "Otthonfelújítási támogatás",
				productInfo: {
					id: "lakasfelujitasi-tamogatas",
					title: "Otthonfelújítási támogatás",
					text: (
						<strong>
							A 2024-től elérhető 6 millió Ft otthonfelújítási támogatásból elvégezhető az 1990 előtt
							épült családi házak energetikai korszerűsítése.
						</strong>
					),
				},
			},
			{
				url: "/otthonteremtesi-es-otthonfelujitasi-tamogatasok/",
				title: "Otthonteremtési támogatások",
				productInfo: {
					id: "otthonteremtesi-es-otthonfelujitasi-tamogatasok",
					title: "Otthonteremtési támogatások",
					text: (
						<strong>
							Tudd meg milyen lakástámogatási lehetőségek érhetők el 2024-ben. Ismerd meg a szabályokat
							előírásokat és feltételeket. Ne marad le semmilyen kedvezményről!
						</strong>
					),
				},
			},

			{
				url: "/babavaro-hitel/",
				title: "Babaváró támogatás",
				productInfo: {
					id: "babavarotamogatas",
					title: "Babaváró kalkulátor",
					text: (
						<>
							Számítsd ki <strong>hitelkalkulátorunkkal</strong>, hogy mennyi babaváró hitelre vagy
							jogosult és <strong>indítsd el akár azonnal</strong> az igénylés folyamatát!
						</>
					),
				},
			},
			{
				url: "/csok/",
				title: "CSOK-hitel kalkulátor",
				productInfo: {
					id: "csok-loan",
					title: "CSOK-hitel kalkulátor",
					text: (
						<>
							Kalkulálj és válogass a szuperolcsó CSOK-hitelek között! <strong>Maximum 3%-os</strong>{" "}
							kamat és futamidő végéig kiszámítható, <strong>fix havi törlesztő</strong>. Felhasználhatod
							használt vagy új lakás vásárlására, vagy építésre.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "supports",
			title: "Támogatások",
			text: (
				<>
					Ellenőrizd, hogy milyen <strong>otthonteremtési támogatásokra</strong> vagy jogosult{" "}
					<strong>{currentYear(true)}.</strong>
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Biztosítás",
		items: [
			{
				url: "/vedelem/bankmonitor-biztonsag/",
				title: "Bankmonitor Biztonság",
				productInfo: {
					id: "bankmonitor-biztonsag",
					title: "Bankmonitor Biztonság",
					text: (
						<>
							<strong>Létrehoztuk neked azt az online hitelfedezeti biztosítást</strong>, ami lakáshitel,
							Babaváró és személyi hitel mellé nyújt komplex megoldást baj esetén.
							<br />
							<br />
							Kalkulálj és tudd meg mennyibe kerül anyagi biztonságod a biztosítás kalkulátorral.
						</>
					),
				},
				badge: <MenuItemBmBadge />,
			},
			{
				url: "/biztositas/eletbiztositas/",
				title: "Kockázati életbiztosítás kalkulátor",
				productInfo: {
					id: "eletbiztositas",
					title: "Kockázati életbiztosítás kalkulátor",
					text: (
						<>
							Nem tudod <strong>melyik a legjobb életbiztosítás</strong> számodra?{" "}
							<strong>A biztosítási kalkulátor megmutatja </strong>
							mennyi havi díjra számíthatsz, független szakértőnk pedig{" "}
							<strong>összehasonlítja az életbiztosítók ajánlatait</strong> és segít megtalálni az
							igényeidnek megfelelőt.
							<br />
							<br /> <strong>Kalkulálj</strong> a személyre szabott ajánlatért!
						</>
					),
				},
			},
			{
				url: "/biztositas/hitelfedezeti-eletbiztositas/",
				title: "Hitelfedezeti életbiztosítás",
				productInfo: {
					id: "hitelfedezeti-eletbiztositas",
					title: "Hitelfedezeti életbiztosítás",
					text: (
						<>
							Biztonság neked és a családodnak, ha hitelt vettél fel. <br />
							<br />
							Kalkulátorunkkal kiszámolhatod, hogy mibe kerülne ez neked.
						</>
					),
				},
			},
			{
				url: "/biztositas/lakasbiztositas-bankmonitor-kedvezmeny/",
				title: "Lakásbiztosítás",
				productInfo: {
					id: "lakasbiztositas",
					title: "Lakásbiztosítás",
					text: (
						<>
							Túl drága már a lakásbiztosításod? Már nem fedezné a biztosítási összeg az esetleges
							károkat? <br />
							<br />
							Találd meg szakértőnk segítségével a számodra megfelelőt a biztosítók objektív
							összehasonlításával.
						</>
					),
				},
			},
			{
				url: "/biztositas/csoportos-szemelybiztositas/",
				title: "Csoportos személybiztosítás",
				productInfo: {
					id: "eletbiztositas",
					title: "Csoportos személybiztosítás",
					text: (
						<>
							Használd ki a csoportos személybiztosítás előnyeit, és élj a vele járó kedvezményekkel.
							Ugyanazon védelem kedvezőbb feltételekkel és költségekkel, szélesebb szolgáltatási körrel,{" "}
							<strong>egyszerű szerződéskötési</strong> folyamattal.
						</>
					),
				},
			},
			{
				url: "/biztositas/egeszsegbiztositas/",
				title: "Egészségbiztosítás",
				productInfo: {
					id: "egeszsegbiztositas",
					title: "Egészségbiztosítás",
					text: (
						<>
							Találd meg szakértőnkkel a megfelelő egészségbiztosítást a biztosítók objektív
							összehasonlításával. Nem lesz többet probléma a magán egészségügyi látogatás!
						</>
					),
				},
			},
		],
		productInfo: {
			id: "biztositas",
			title: "Biztosítások",
			text: (
				<>
					<strong>Kézzelfogható biztonság</strong> már havi pár ezer forinttól?
					<br />
					<br />
					Kalkulálj a személyre szabott ajánlatért!
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Deviza",
		items: [
			{
				url: "/deviza/usd-arfolyam/",
				title: "Dollár árfolyam",
				productInfo: {
					id: "eletbiztositas",
					title: "Dollár árfolyam",
					text: (
						<>
							Hasonlítsd össze a dollár deviza és valuta árfolyamokat!
							<br />
							<br />
							Tudd meg, hogyan tudsz devizában megtakarítani, mi az aktuális dollár árfolyam és melyik
							bank váltja a legjobban.
						</>
					),
				},
			},
			{
				url: "/deviza/euro-arfolyam/",
				title: "Euró árfolyam",
				productInfo: {
					id: "eletbiztositas",
					title: "Euró árfolyam",
					text: (
						<>
							Hasonlítsd össze az euró deviza és valuta árfolyamokat!
							<br />
							<br />
							Tudd meg, hogyan tudsz devizában megtakarítani, mi az aktuális euró árfolyam és melyik bank
							váltja a legjobban.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "deviza",
			title: "Devizák",
			text: (
				<>
					A hazai bankok naprakész devizaárfolyam és valuta árfolyam adatai egy helyen.
					<br />
					<br />
					Hasonlítsd össze a valuta és deviza vételi- és eladási árfolyamokat.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
];
export const CORPORATE_MENU: MenuItemCategory[] = [
	{
		title: "Hitelek",
		items: [
			{
				title: "Mennyi hitelt tud felvenni a cégem?",
				iconElement: <FontAwesomeIcon icon={fasCircleQuestion} />,
				url: "/vallalati/hitel/mennyi-hitelt-kaphat-a-cegem/",
			},
			{
				title: "100 millió forint feletti hitel",
				iconElement: <FontAwesomeIcon icon={fasMoneyCheckDollarPen} />,
				url: "/vallalati/hitel/100-millio-feletti/",
			},
			{
				title: "Folyószámla hitel",
				iconElement: <FontAwesomeIcon icon={fasMoneyCheckDollar} />,
				url: "/vallalati/hitel/",
			},
			{
				title: "Forgóeszköz hitel",
				iconElement: <FontAwesomeIcon icon={fasBoxDollar} />,
				url: "/vallalati/hitel/?loanType=CURRENT_ASSET_NON_REVOLVING_LOAN",
			},
			{
				title: "Beruházási hitelek",
				iconElement: <FontAwesomeIcon icon={fasMoneyBills} />,
				url: "/vallalati/hitel/?loanType=INVESTMENT_LOAN",
			},
			{
				title: "Széchenyi hitel",
				iconElement: <FontAwesomeIcon icon={fasCalculator} />,
				url: "/vallalati/hitel/szechenyi-hitel/",
			},
			{
				title: "Faktoring",
				iconElement: <FontAwesomeIcon icon={fasFileInvoiceDollar} />,
				url: "/vallalati/hitel/faktoring/",
			},
		],
		productInfo: {
			id: "corporate-loans",
			title: "Vállalati hitelek",
			text: (
				<>
					<strong>Folyószámlahitelek</strong> a likviditási problémák kezelésére,{" "}
					<strong>forgóeszköz hitelek</strong> vevő- és készletfinanszírozásra,{" "}
					<strong>beruházási hitelek</strong> a dinamikus fejlődés finanszírozására,{" "}
					<strong>faktoring</strong>, ha gyorsan forrásra van szükség.{" "}
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe variant="corporate" size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Bankszámlák",
		items: [
			{
				title: "Vállalkozói bankszámlák",
				iconElement: <FontAwesomeIcon icon={fasPiggyBank} />,
				url: "/vallalati/bankszamla/",
			},
			{
				title: "Online nyitható bankszámlák",
				iconElement: <FontAwesomeIcon icon={fasPiggyBank} />,
				url: "/vallalati/bankszamla/kkv-bankszamla-osszehasonlito/",
				productInfo: {
					id: "compare-free-corporate-accounts",
					title: "Online nyitható vállalati bankszámlák összehasonlítása",
					text: (
						<>
							<strong>Hasonlítsd össze</strong> egyszerűen az <strong>online nyitható vállalati</strong>{" "}
							bankszámlákat, válaszd ki a számodra legmegfelelőbbet és <strong>nyisd meg online</strong>{" "}
							pillanatok alatt!
							<strong>Spórolj</strong> évente akár <strong>több tízezer forintot!</strong>
						</>
					),
				},
			},
			{
				title: "Ingyenes UniCredit FixPont Vállalkozói bankszámla",
				iconElement: <FontAwesomeIcon icon={fasPiggyBank} />,
				url: "/vallalati/bankszamla/vallalkozoi-szamla-unicredit/",
				productInfo: {
					id: "Unciredit",
					title: "Unicredit FixPont vállalkozói bankszámla",
					text: (
						<>
							Ingyenes UniCredit FixPont vállalkozói bankszámla igénylés, 18 hónapig díjmentes,
							bankfiókban nem igényelhető.
						</>
					),
				},
			},
			{
				title: "Ingyenes Raiffeisen Vállalkozói bankszámla",
				iconElement: <FontAwesomeIcon icon={fasPiggyBank} />,
				url: "/vallalati/bankszamla/ingyenes-vallalkozoi-bankszamla/",
				productInfo: {
					id: "raiffeisen",
					title: "Raiffeisen ingyenes vállalkozói számla",
					text: (
						<>
							Ingyenes vállalkozói bankszámla a Raiffeisen Banktól. Egyszerű online vállalkozói bankszámla
							nyitás a Bankmonitor szakértőinek segítségével.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "corporate-bank-accounts",
			title: "Vállalkozói bankszámlák",
			text: (
				<>
					Más bankszámlára van szüksége egy <strong>induló vállalkozásnak</strong> és egy régóta működő,{" "}
					<strong>nagyobb cégnek</strong>.<br />
					<br /> Nem csak a havi díjak, hanem a tranzakciós költségek is nagyon különbözőek, ezért éves
					szinten akár több százezer forintot is meg lehet takarítani egy jó választással.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe variant="corporate" size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Tanácsadás",
		items: [
			{
				title: "Vállalati tanácsadás",
				iconElement: <FontAwesomeIcon icon={farHandshake} />,
				url: "/vallalati/vallalati-tanacsadas/",
				productInfo: {
					id: "corporate-advice",
					title: "Vállalati tanácsadás",
					text: (
						<>
							500 millió forint éves bevételi szint felett van a céged, de célod a további növekedés és
							fejlődés? Akkor a vállalati tanácsadás szolgáltatásunk neked szól!
						</>
					),
				},
			},
		],
		productInfo: {
			id: "corporate-guidance",
			title: "Tanácsadás",
			text: (
				<>
					Azért, hogy minél gyorsabban megkapd a szükséges hitelt, átnézzük az üzleti terved, megmutatjuk a
					finanszírozási alternatívákat, elkészítjük a bankok számára szükséges ügyletleírást, összeállítjuk a
					hitelkérelmet, menedzseljük a banki tárgyalásokat, valamint kidolgozzuk az optimális
					hitelkonstrukciót.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe variant="corporate" size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Pénzügyi Tudatosság",
		items: [
			{
				title: "Pénzügyi Tudatosság Program",
				iconElement: <FontAwesomeIcon icon={farHandshake} />,
				url: "/vallalati/penzugyi-tudatossag-program/",
				productInfo: {
					id: "penzugyi-tudatossag-program",
					title: "Pénzügyi Tudatosság Program",
					text: (
						<>
							Vegyél részt vállalatoddal a Bankmonitor ingyenes Pénzügyi Tudatosság Programjában, melynek
							keretein belül 1.5 órás pénzügyi előadásokon vehetnek részt a cég dolgozói.
							<br />
							<br /> Az oktatások célja, hogy az emberek tudatosabban kezeljék pénzügyeiket és
							megteremtsék maguknak az anyagi biztonságot.
						</>
					),
				},
			},
		],
		productInfo: {
			id: "Financial Awareness",
			title: "Pénzügyi Tudatosság",
			text: (
				<>
					Oktatásokat, képzéseket szervezünk dolgozóid számára, ezáltal növekedhet a munkavállalóid
					lojalitása. A cél, hogy alkalmazottaid könnyebben és gyorsabban tudjanak helyes pénzügyi döntéseket
					hozni.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe variant="corporate" size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
	{
		title: "Biztosítások",
		items: [
			{
				title: "Vállalati egészségbiztosítás",
				iconElement: <FontAwesomeIcon icon={farHandshake} />,
				url: "/vallalati/vallalati-egeszsegbiztositas/",
			},
		],
		productInfo: {
			id: "corporate-health-insurance",
			title: "Vállalati egészségbiztosítás",
			text: (
				<>
					Szerezz versenyelőnyt a munkaerőpiacon, növeld a dolgozóid lojalitását és csökkentsd a
					betegszabadságok számát céges egészségbiztosítással.
				</>
			),
		},
		infoBoxContent: <NewsletterSubscribe variant="corporate" size="sm" ga4Event={{ instanceId: "menu" }} />,
	},
];

export const RETAIL_MOBILE_MENU: Menu[] = [
	...RETAIL_MENU,
	{
		isHr: true,
	},
	{
		title: "Médiatár",
		url: "/category/mediatar/",
		iconElement: <FontAwesomeIcon icon={farNewspaper} />,
	},
	{
		title: "Jobb tudni",
		url: "/jobb-tudni/",
		iconElement: <FontAwesomeIcon icon={fasQuestion} />,
	},
	{
		title: "Bankmonitorról",
		url: "/a-bankmonitorrol/",
	},
	{
		title: "Karrier",
		url: "/karrier/",
	},
];

export const CORPORATE_MOBILE_MENU: Menu[] = [
	{
		...CORPORATE_MENU[0],
		title: "Vállalati hitelek",
		productCount: 182,
	},
	CORPORATE_MENU[1].items[0],
	CORPORATE_MENU[1].items[1],
	CORPORATE_MENU[2].items[0],
	{
		isHr: true,
	},
	{
		title: "Médiatár",
		url: "/category/mediatar/",
		iconElement: <FontAwesomeIcon icon={farNewspaper} />,
	},
	{
		title: "Deviza",
		url: "/deviza/euro-arfolyam/",
	},
	{
		title: "Jobb tudni",
		url: "/jobb-tudni/",
		iconElement: <FontAwesomeIcon icon={fasQuestion} />,
	},
	{
		title: "Bankmonitorról",
		url: "/a-bankmonitorrol/",
	},
	{
		title: "Karrier",
		url: "/karrier/",
	},
];

export const MOSAIC_MOBILE_MENU: MosaicMenu[] = [
	{
		title: "Lakáshitel",
		alt: "Lakáshitel kalkulátor",
		url: "/lakashitel-kalkulator/",
		icon: faHouse,
	},
	{
		title: "Bankszámla",
		alt: "Bankszámla kalkulátor",
		url: "/bankszamla/",
		icon: faCreditCard,
	},
	{
		title: "Személyi kölcsön",
		alt: "Személyi kölcsön kalkulátor",
		url: "/szemelyi-kolcson/",
		icon: faMoneyBills,
	},
	{
		title: "Hitelkalkulátor",
		alt: "Hitelkalkulátor",
		url: "/hitelkalkulator/",
		icon: faCalculator,
	},
	{
		title: "Babaváró hitel",
		alt: "Babaváró hitel",
		url: "/babavaro-hitel/",
		icon: faBaby,
	},
	{
		title: "Lakástakarék",
		alt: "Lakástakarék kalkulátor",
		url: "/lakastakarek/",
		icon: faPiggyBank,
	},
];

export const MOSAIC_MOBILE_MENU_CORPORATE: MosaicMenu[] = [
	{
		title: "Vállalkozói hitel feltételei",
		alt: "Vállalkozói hitel feltételei",
		url: "/vallalati/hitel/hitelhez-segitjuk-vallalkozasodat/",
		icon: faMoneyCheckPen,
	},
	{
		title: "Vállalkozói hitel kereső",
		alt: "Vállalkozói hitel kereső",
		url: "/vallalati/hitel/",
		icon: faSearchDollar,
	},
	{
		title: "Vállalkozói hitel kalkulátor",
		alt: "Vállalkozói hitel kalkulátor",
		url: "/vallalati/hitel/mennyi-hitelt-kaphat-a-cegem/",
		icon: faCalculator,
	},
	{
		title: "100 millió Ft feletti hitel",
		alt: "100 millió Ft feletti hitel",
		url: "/vallalati/hitel/100-millio-feletti/",
		icon: faMoneyBills,
	},
	{
		title: "Széchenyi Kártya",
		alt: "Széchenyi Kártya",
		url: "/vallalati/hitel/szechenyi-hitel/",
		icon: faAddressCard,
	},
	{
		title: "Vállalkozói számla",
		alt: "Vállalkozói számla",
		url: "/vallalati/bankszamla/",
		icon: faCreditCard,
	},
];

export const FOOTER_MENU_BLOCKS = [
	{
		groupTitle: "Lakáshitel",
		groupId: "lakashitel",
		// groupLink: '/lakashitel-kalkulator/',
		groupItems: [
			{
				menuPoint: "Lakáshitel",
				url: "/lakashitel-kalkulator/",
			},
			{
				menuPoint: "Szabad felhasználású jelzáloghitel",
				url: "/lakashitel-kalkulator/szabad-felhasznalasu-jelzaloghitel-kalkulator/",
			},
			{
				menuPoint: "Építési hitel",
				url: "/epitesi-hitel/",
			},
			{
				menuPoint: "Bankmonitor lakáshitel kamatkedvezmény",
				url: "/bankmonitor-lakashitel-kamatkedvezmeny/",
			},
			{
				menuPoint: "Lakáshitel felújításra",
				url: "/hitel-lakasfelujitasra/",
			},
			{
				menuPoint: "Mennyi lakáshitelt kaphatok?",
				url: "/lakashitel-kalkulator/mennyi-lakashitelt-kaphatok/",
			},
			{
				menuPoint: "Lakáshitel kiváltás",
				url: "/hitelkivaltas-reszletek/",
			},
			{
				menuPoint: "CSOK-hitel",
				url: "/csok/",
			},
			{
				menuPoint: "Fogyasztóbarát lakáshitel",
				url: "/fogyasztobarat-lakashitel/",
			},
		],
	},
	{
		groupTitle: "Támogatások",
		groupId: "tamogatasok",
		// groupLink: '/felujitasi-hitel/',
		groupItems: [
			{
				menuPoint: "Babaváró támogatás",
				url: "/babavaro-hitel/",
			},
		],
	},
	{
		groupTitle: "Személyi kölcsön",
		groupId: "szemelyiKolcson",
		// groupLink: '/szemelyi-kolcson/',
		groupItems: [
			{
				menuPoint: "Személyi kölcsön kalkulátor",
				url: "/szemelyi-kolcson/",
			},
			{
				menuPoint: "Mennyi kölcsönt kaphatok?",
				url: "/mennyi-szemelyi-kolcsont-kaphatok/",
			},
			{
				menuPoint: "Prémium személyi kölcsön",
				url: "/szemelyi-kolcson-premium/",
			},
			{
				menuPoint: "Nagyösszegű személyi kölcsön",
				url: "/nagyosszegu-szemelyi-kolcson/",
			},
			{
				menuPoint: "Autóhitel",
				url: "/autohitel/",
			},
			{
				menuPoint: "Személyi kölcsön felújításra",
				url: "/felujitasi-hitel/",
			},
		],
	},
	{
		groupTitle: "Megtakarítások",
		groupId: "megtakaritasok",
		// groupLink: '/nyugdij-megtakaritas/',
		groupItems: [
			{
				menuPoint: "Nyugdíj megtakarítás",
				url: "/nyugdij-megtakaritas/",
			},
			{
				menuPoint: "Nyugdíjbiztosítás",
				url: "/megtakaritasok/nyugdijbiztositas/",
			},
			{
				menuPoint: "Nyugdíjpénztár",
				url: "/megtakaritasok/onkentes-nyugdijpenztar/",
			},
			{
				menuPoint: "Állampapír",
				url: "/megtakaritasok/allampapir/",
			},
			{
				menuPoint: "Befektetési alap",
				url: "/megtakaritasok/befektetesi-alap/",
			},
			{
				menuPoint: "Bankbetét",
				url: "/megtakaritasok/bankbetet/",
			},
			{
				menuPoint: "Lakástakarék",
				url: "/megtakaritasok/lakastakarek/",
			},
		],
	},
	{
		groupTitle: "Bankszámlák",
		groupId: "bankszamlak",
		// groupLink: '/bankszamla/',
		groupItems: [
			{
				menuPoint: "Bankszámla kalkulátor",
				url: "/bankszamla/",
			},
			{
				menuPoint: "Ingyenes bankszámla online igénylés",
				url: "/bankszamla/ingyenes-bankszamla-online/",
			},
			{
				menuPoint: "Magas jövedelemhez",
				url: "/bankszamla/?receiptOfMoneyAmount=400000&age=40&internetTransferAmount=35000&fixedTransferCount=2&fixedTransferAmount=25000&directDebitCount=5&directDebitAmount=50000&cashWithdrawalOwnAtmAmount=100000&cardPurchaseCount=50&cardPurchaseAmount=150000&smsServiceCardUsage=true&sort=FIRST_AND_SECOND_YEAR_TOTAL_FEE&start=0",
			},
			{
				menuPoint: "Gyakori utaláshoz",
				url: "/bankszamla/?receiptOfMoneyAmount=200000&internetTransferCount=8&internetTransferAmount=70000&fixedTransferCount=3&fixedTransferAmount=20000&directDebitCount=3&directDebitAmount=30000&cashWithdrawalOwnAtmAmount=30000&cardPurchaseCount=20&cardPurchaseAmount=50000&smsServiceCardUsage=true&sort=FIRST_AND_SECOND_YEAR_TOTAL_FEE&start=0",
			},
			{
				menuPoint: "Diákoknak",
				url: "/bankszamla/?receiptOfMoneyAmount=30000&salary=false&userType=student&age=18&internetTransferCount=1&internetTransferAmount=5000&directDebitCount=0&directDebitAmount=0&cashWithdrawalOwnAtmCount=1&cashWithdrawalOwnAtmAmount=10000&cardPurchaseCount=4&cardPurchaseAmount=10000&smsServiceCardUsage=true&sort=FIRST_AND_SECOND_YEAR_TOTAL_FEE&start=0",
			},
			{
				menuPoint: "Nyugdíjasoknak",
				url: "/bankszamla/?receiptOfMoneyAmount=80000&salary=false&pension=true&userType=pensioner&age=60&internetTransferCount=0&internetTransferAmount=0&fixedTransferCount=1&fixedTransferAmount=10000&directDebitCount=4&directDebitAmount=25000&cashWithdrawalOwnAtmAmount=35000&cardPurchaseCount=2&cardPurchaseAmount=10000&smsServiceCardUsage=true&sort=FIRST_AND_SECOND_YEAR_TOTAL_FEE&start=0",
			},
			{
				menuPoint: "Minimálbérhez",
				url: `/bankszamla/?receiptOfMoneyAmount=${Config.getMinWage()}&internetTransferCount=2&internetTransferAmount=15000&directDebitCount=0&directDebitAmount=0&cashWithdrawalOwnAtmAmount=50000&cardPurchaseCount=2&cardPurchaseAmount=15000&sort=FIRST_AND_SECOND_YEAR_TOTAL_FEE&start=0`,
			},
		],
	},
	{
		groupTitle: "Egyéb hitelek",
		groupId: "egyebHitelek",
		// groupLink: '/hitelkartya/',
		groupItems: [
			{
				menuPoint: "Hitelkártya kalkulátor",
				url: "/hitelkartya/",
			},
		],
	},
	{
		groupTitle: "Online termékek",
		groupId: "onlineTermekek",
		// groupLink: '/bankszamla/ingyenes-bankszamla-online/',
		groupItems: [
			{
				menuPoint: "Ingyenes bankszámla online igénylés",
				url: "/bankszamla/ingyenes-bankszamla-online/",
			},
			{
				menuPoint: "Gyorsított online Babaváró hitel",
				url: "/erste-babavaro-hitel/",
			},
		],
	},
	{
		groupTitle: "Vállalati",
		groupId: "vallalati",
		// groupLink: '/vallalati/',
		groupItems: [
			{
				menuPoint: "Mennyi hitelt kaphat cégem?",
				url: "/vallalati/hitel/mennyi-hitelt-kaphat-a-cegem/",
			},
			{
				menuPoint: "Növekedési hitel (NHP)",
				url: "/vallalati/hitel/novekedesi-hitel/",
			},
			{
				menuPoint: "Széchenyi Kártya",
				url: "/vallalati/hitel/szechenyi-hitel/",
			},
			{
				menuPoint: "Vállalkozói bankszámla kereső",
				url: "/vallalati/bankszamla/",
			},
			{
				menuPoint: "100 millió Ft feletti hitelek",
				url: "/vallalati/hitel/100-millio-feletti/",
			},
			{
				menuPoint: "Forgóeszköz hitelek",
				url: "/vallalati/hitel/?loanType=CURRENT_ASSET_NON_REVOLVING_LOAN",
			},
			{
				menuPoint: "Folyószámla hitelek",
				url: "/vallalati/hitel/",
			},
			{
				menuPoint: "Beruházási hitelek",
				url: "/vallalati/hitel/?loanType=INVESTMENT_LOAN",
			},
		],
	},
];

export const FOOTER_MENU_ROW = [
	{
		menuPoint: "Rólunk",
		url: "/rolunk/",
	},
	{
		menuPoint: "Impresszum",
		url: "/impresszum/",
	},
	{
		menuPoint: "Jogi nyilatkozat",
		url: "/jogi-nyilatkozat/",
	},
	{
		menuPoint: "Üzletszabályzat",
		url: "/uzletszabalyzat/",
	},
	{
		menuPoint: "Adatvédelmi szabályzat",
		url: "/adatvedelem/",
	},
	{
		menuPoint: "Közzététel",
		url: "/kozzetetel/",
	},
	{
		menuPoint: "Süti tájékoztató",
		url: "/cookie-policy/",
	},
	{
		menuPoint: "Panaszkezelési szabályzat",
		url: "/panaszkezelesi-szabalyzat/",
	},
	{
		menuPoint: "Kapcsolat",
		url: "/kapcsolat/",
	},
	{
		menuPoint: "Etikai kódex",
		url: Config.buildSsrFriendlyUrl("BM_BASE_DOCS_URL", "/public/Etikai_kodex_2021.pdf"),
	},
];
